import { __rest, __assign, __spreadArray, __read } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import clsx from 'clsx';
import { Item as $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 } from '../../external/@react-stately/collections/dist/import.mjs.js';
import { useListBox } from 'react-aria';
import styles from './ListBox.module.scss.js';
import { Item } from './item/Item.js';

var ListBox = function (_a) {
    var _b;
    var ItemComponent = _a.itemComponent, listBoxRef = _a.listBoxRef, header = _a.header, footer = _a.footer, className = _a.className, wrapperClassName = _a.wrapperClassName, style = _a.style, size = _a.size, state = _a.state; _a.loadingState; var onLoadMore = _a.onLoadMore, props = __rest(_a, ["itemComponent", "listBoxRef", "header", "footer", "className", "wrapperClassName", "style", "size", "state", "loadingState", "onLoadMore"]);
    var localRef = useRef(null);
    var ref = listBoxRef || localRef;
    var listBoxProps = useListBox(props, state, ref).listBoxProps;
    var onScroll = function (e) {
        var scrollOffset = e.currentTarget.scrollHeight - e.currentTarget.clientHeight * 2;
        if (e.currentTarget.scrollTop > scrollOffset && onLoadMore) {
            onLoadMore();
        }
    };
    return (jsxs("div", __assign({ className: clsx(styles.menuListWrapper, wrapperClassName), tabIndex: -1, style: style }, { children: [header, jsx("ul", __assign({}, listBoxProps, { className: clsx(styles.menuList, (_b = {},
                    _b[styles.menuListLarge] = size === 'l',
                    _b), className), ref: ref, onScroll: onScroll }, { children: __spreadArray([], __read(state.collection), false).map(function (item) {
                    return ItemComponent ? (jsx(ItemComponent, { item: item, state: state }, item.key)) : (jsx(Item, __assign({ item: item, state: state }, { children: item.rendered }), item.key));
                }) })), footer] })));
};
ListBox.Item = $c1d7fb2ec91bae71$export$6d08773d2e66f8f2;

export { ListBox };
